// Translations for the Support page.
const supportDict = [
  { en: "Helpdesk / Support", sw: "Dawati la Usaidizi / Msaada" },
  { en: "Submit tickets and track status. (Placeholder UI)", sw: "Wasilisha tiketi na fuatilia hali. (Muundo wa Awali)" },
  { en: "Submit Ticket", sw: "Wasilisha Tiketi" },
];

export default supportDict;
